/*
 * @Descripttion: 
 * @version: 
 * @Author: Blau
 * @Date: 2023-10-23 10:33:15
 * @LastEditors: Andy
 * @LastEditTime: 2023-10-23 10:39:10
 */
import hasPermi from './hasPermi'

const install = function(Vue) {
  Vue.directive('hasPermi', hasPermi)
}

if (window.Vue) {
  window['hasPermi'] = hasPermi
  Vue.use(install); // eslint-disable-line
}

export default install


// WEBPACK FOOTER //
// ./src/directive/index.js